import { Injectable } from '@angular/core';

import {
  AppRoute,
  AppRouteNativeSettings,
  AprimaTransitionRequest,
  WebViewManager,
} from 'webcommon/shared';

import { BridgeService } from '../BridgeService';
import { DeviceSettingsRepository } from '../DeviceSettingsRepository';

@Injectable({
  providedIn: 'root',
})
export class WebViewManagerService implements WebViewManager {
  static readonly ajsFactoryName = 'WebViewManager';

  private webViewManager: WebViewManager | null = null;

  constructor(
    private bridgeService: BridgeService,
    private deviceSettingsRepository: DeviceSettingsRepository,
  ) {

  }

  loadConfiguration(browserWebViewManager: WebViewManager, hostedWebViewManager: WebViewManager): void {
    if (this.webViewManager !== null) {
      throw new Error('webViewManager has already been set');
    }

    if (this.deviceSettingsRepository.isStandaloneBrowser) {
      // eslint-disable-next-line no-console
      console.info('Using browser WebViewManager for standalone browser');
      this.webViewManager = browserWebViewManager;
    } else if (this.deviceSettingsRepository.isDevice || this.deviceSettingsRepository.isPrm) {
      // eslint-disable-next-line no-console
      console.info('Using hosted WebViewManager');
      this.webViewManager = hostedWebViewManager;
    } else {
      // eslint-disable-next-line no-console
      console.info('Using browser WebViewManager');
      this.webViewManager = browserWebViewManager;
    }
  }

  private validateConfiguration(): WebViewManager {
    if (this.webViewManager === null) {
      throw new Error('webViewManager has not been set');
    }
    return this.webViewManager;
  }

  activateView(appRoute: AppRoute, transition: AprimaTransitionRequest): boolean {
    const webViewManager = this.validateConfiguration();
    return webViewManager.activateView(appRoute, transition);
  }

  goBack(): void {
    const webViewManager = this.validateConfiguration();
    webViewManager.goBack();
  }

  setupPage(nativeSettings: AppRouteNativeSettings): void {
    this.bridgeService.fireEvent('setupPage', nativeSettings);
  }
}
